export default class Subscribe {
    constructor() {
        this.state = 'fill';
        this.bind();
    }

    // Метод возвращает шаблон попапа
    popupTemplate() {
        return `
           <div class="modal fade simple-modal callback-modal" id="callback-modal" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">

                        <div class="modal-body">

                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">Подписка на товар</div>
                            <div class="simple-modal__subtitle">
                                Оставьте ваш Email для опововещения о поступлении товара
                            </div>

                            <form class="callback-modal__form">
                                <div class="callback-modal__form-body">
                                    <div class="form-group">
                                        <input type="email"
                                            class="callback-modal__input callback-modal__input--name lb-input"
                                            name="email"
                                            placeholder="Ваш Email"
                                            required
                                        />
                                    </div>
                                    <div class="callback-modal__success hidden">Спасибо, уведомление придет вам на почту</div>
                                </div>

                                <div class="callback-modal__btn-block" style="margin-top: 49px;">
                                    <button class="button-icon callback-modal__submit">
                                        <span class="button-icon__left">
                                            <img class="button-icon__icon" src="${app.assetPath}/img/icons/smartphone-white.svg" alt="" />
                                        </span>
                                        <span class="button-icon__right">Подписаться</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
`;
    }

    // Метод вешает обработчик на клик кнопки подписаться
    bind() {
        if ($('.subscribe').attr("data-is-subscribed") == "N") {
            $('.subscribe').on('click', this.onTriggerClick.bind(this));
        }
    }

    // Метод вешает обработчик на кнопки в попапе
    bindLazy() {
        if (this.state = 'sentAuth') {
            this.addSubscription();
            this.$popup.find('.button-icon__right').on('click', this.onSubmit.bind(this));
        } else {
            this.$popup.find('.button-icon__right').on('click', this.onSubmit.bind(this));
        }
    }

    onTriggerClick(e) {
        e.preventDefault();
        this.show();
    }

    // Вывод попапа на экран
    show() {
        if (!this.$popup) {
            // Because of empty #text-node
            this.$popup = $(this.popupTemplate()).eq(0);
            $('body').append(this.$popup);
            let infoContainer = document.querySelector(".product__buy-block-right.subscribe button.product-buy-button");
            const isAuth = infoContainer.getAttribute("data-user-authorized");
            if (isAuth === "Y") {
                this.setState('sentAuth');
            } else {
                this.setState('fill');
            }
            this.bindLazy();
        }
        this.$popup.modal('show');
    }

    // Установка состояния попапа
    setState(state) {
        switch (state) {
            case 'sent':
                this.$popup.find('.callback-modal__success').removeClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Закрыть');
                this.state = 'sent';
                break;

            case 'fill':
                this.$popup.find('.callback-modal__success').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Отправить');
                this.$popup.find('form').get(0).reset();
                this.state = 'fill';
                break;

            case 'sentAuth':
                this.$popup.find('.callback-modal__success').removeClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.simple-modal__subtitle').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Закрыть');
                $('.callback-modal__input.callback-modal__input--name.lb-input').removeAttr('required');
                this.$popup.find('form').get(0).reset();
                this.state = 'sentAuth';
                break;
        }
    }

    // Метод отправляет запрос на добавление подписки для авторизованного пользователя
    addSubscription() {
        var button = document.querySelector(".product__buy-block-right.subscribe button.product-buy-button");
        var userId = button.getAttribute("data-user-id");
        var storeId = button.getAttribute("data-store-id");
        var itemId = button.getAttribute("data-item-id");

        const self = this;
        $.ajax({
            url: '/local/public/subscribe.php',
            dataType: 'json',
            method: 'post',
            data: {
                userId,
                storeId,
                itemId,
                ajax: 'Y',
                mode: 'sub',
                formId: 'subscribe',
            }
        }).done((response) => {
            if (response.status == 'error') {
                let errors = '';

                if (response.error) {
                    errors = response.error;
                } else {
                    for (var i = 0; i < response.errors.length; i++) {
                        errors += response.errors[i].text + '\n';
                    }
                }

                alert(errors);
                return;
            } else {
                $('.subscribe').html("Вы подписаны")
            }
            self.setState('sent');
        });
    }

    // Если пользователь не авторизован, метод отслеживает событие сабмита формы с вводом почты, если событие срабартывает
    // отправляется ajax запрос с данными формы и переключается стейт на закрытие попапа
    onSubmit(e) {
        e.preventDefault();

        switch (this.state) {
            //case 'sentAuth':
            case 'sent':
                this.$popup.modal('hide');
                break;
            case 'fill':
            default:
                var email;
                if (this.$popup.find('input[name="email"]').val()) {
                    email = this.$popup.find('input[name="email"]').val();
                } else {
                    email = "";
                }
                var button = document.querySelector(".product__buy-block-right.subscribe button.product-buy-button");
                var userId = button.getAttribute("data-user-id");
                var storeId = button.getAttribute("data-store-id");
                var itemId = button.getAttribute("data-item-id");

                const self = this;
                $.ajax({
                    url: '/local/public/subscribe.php',
                    dataType: 'json',
                    method: 'post',
                    data: {
                        email,
                        userId,
                        storeId,
                        itemId,
                        ajax: 'Y',
                        mode: 'sub',
                        formId: 'subscribe',
                        sessid: app.sessid
                    }
                }).done((response) => {
                    if (response.status == 'error') {
                        let errors = '';

                        if (response.error) {
                            errors = response.error;
                        } else {
                            for (var i = 0; i < response.errors.length; i++) {
                                errors += response.errors[i].text + '\n';
                            }
                        }

                        alert(errors);
                        return;
                    } else {
                        $('.subscribe').html("Вы подписаны")
                    }

                    self.setState('sent');
                });
                break;
        }
    }
}